<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M15.1875 2.95312H2.8125C2.55143 2.95313 2.30105 3.05684 2.11644 3.24144C1.93184 3.42605 1.82813 3.67643 1.82812 3.9375V14.0625C1.82812 14.3236 1.93184 14.574 2.11644 14.7586C2.30105 14.9432 2.55143 15.0469 2.8125 15.0469H15.1875C15.4486 15.0469 15.699 14.9432 15.8836 14.7586C16.0682 14.574 16.1719 14.3236 16.1719 14.0625V3.9375C16.1719 3.67643 16.0682 3.42605 15.8836 3.24144C15.699 3.05684 15.4486 2.95313 15.1875 2.95312ZM2.67188 14.0625V3.9375C2.67188 3.9002 2.68669 3.86444 2.71306 3.83806C2.73944 3.81169 2.7752 3.79688 2.8125 3.79688H5.76562V14.2031H2.8125C2.7752 14.2031 2.73944 14.1883 2.71306 14.1619C2.68669 14.1356 2.67188 14.0998 2.67188 14.0625ZM15.3281 14.0625C15.3281 14.0998 15.3133 14.1356 15.2869 14.1619C15.2606 14.1883 15.2248 14.2031 15.1875 14.2031H6.60938V3.79688H15.1875C15.2248 3.79688 15.2606 3.81169 15.2869 3.83806C15.3133 3.86444 15.3281 3.9002 15.3281 3.9375V14.0625Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'CollapseNavigationIcon18'
};
</script>

<style scoped>

</style>